import { API_BASE_URL } from './apiBase';

const ADMIN_TOKEN_KEY = 'verissa_admin_token';

const notifyAdminAuthChanged = () => {
  if (typeof window !== 'undefined' && window.dispatchEvent) {
    window.dispatchEvent(new CustomEvent('verissa-admin-auth-changed'));
  }
};

const handleResponse = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || 'Request fallida');
  }
  return data;
};

export const adminLogin = async ({ email, password }) => {
  const response = await fetch(`${API_BASE_URL}/admin/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  return handleResponse(response);
};

export const getAdminMe = async (token) => {
  const response = await fetch(`${API_BASE_URL}/admin/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return handleResponse(response);
};

export const createAdminProduct = async (token, payload) => {
  const response = await fetch(`${API_BASE_URL}/admin/products`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
};

export const createAdminCategory = async (token, payload) => {
  const response = await fetch(`${API_BASE_URL}/admin/categories`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
};

export const listAdminProducts = async (token) => {
  const response = await fetch(`${API_BASE_URL}/admin/products`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return handleResponse(response);
};

export const getAdminProduct = async (token, productId) => {
  const response = await fetch(`${API_BASE_URL}/admin/products/${productId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return handleResponse(response);
};

export const updateAdminProduct = async (token, productId, payload) => {
  const response = await fetch(`${API_BASE_URL}/admin/products/${productId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
};

export const deleteAdminProduct = async (token, productId) => {
  const response = await fetch(`${API_BASE_URL}/admin/products/${productId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return handleResponse(response);
};

export const uploadAdminImage = async (token, file) => {
  const formData = new FormData();
  formData.append('image', file);

  const response = await fetch(`${API_BASE_URL}/admin/upload-image`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  return handleResponse(response);
};

export const listAttributeDefinitions = async (token) => {
  const response = await fetch(`${API_BASE_URL}/admin/attribute-definitions`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return handleResponse(response);
};

export const createAttributeDefinition = async (token, payload) => {
  const response = await fetch(`${API_BASE_URL}/admin/attribute-definitions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
};

export const updateAttributeDefinition = async (token, attributeId, payload) => {
  const response = await fetch(
    `${API_BASE_URL}/admin/attribute-definitions/${attributeId}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    }
  );
  return handleResponse(response);
};

export const deleteAttributeDefinition = async (token, attributeId) => {
  const response = await fetch(
    `${API_BASE_URL}/admin/attribute-definitions/${attributeId}`,
    {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return handleResponse(response);
};

export const createAttributeOptionDefinition = async (
  token,
  attributeId,
  payload
) => {
  const response = await fetch(
    `${API_BASE_URL}/admin/attribute-definitions/${attributeId}/options`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    }
  );
  return handleResponse(response);
};

export const updateAttributeOptionDefinition = async (
  token,
  optionId,
  payload
) => {
  const response = await fetch(
    `${API_BASE_URL}/admin/attribute-option-definitions/${optionId}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    }
  );
  return handleResponse(response);
};

export const deleteAttributeOptionDefinition = async (token, optionId) => {
  const response = await fetch(
    `${API_BASE_URL}/admin/attribute-option-definitions/${optionId}`,
    {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return handleResponse(response);
};

export const getStoredAdminToken = () =>
  window.localStorage.getItem(ADMIN_TOKEN_KEY);

export const setStoredAdminToken = (token) => {
  window.localStorage.setItem(ADMIN_TOKEN_KEY, token);
  notifyAdminAuthChanged();
};

export const clearStoredAdminToken = () => {
  window.localStorage.removeItem(ADMIN_TOKEN_KEY);
  notifyAdminAuthChanged();
};
